import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { TechCoverContact } from "../models/TechCoverContact";
import { TechCoverContactEdit } from "../models/TechCoverContactEdit";

@Injectable({
  providedIn: "root",
})
export class TechCoverContactService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/techCoverContacts`;

  constructor(private http: HttpClient) {}

  public async getAllContactsForEdit(): Promise<TechCoverContactEdit[]> {
    const response = await firstValueFrom(this.http.get<TechCoverContact[]>(`${this.baseUrl_V2}`));
    return response.map((x) => {
      return new TechCoverContactEdit().deserialize(x);
    });
  }

  public getContact(famCode: string): Observable<TechCoverContact> {
    return this.http.get<TechCoverContact>(`${this.baseUrl_V2}/${famCode}`);
  }

  public async add(contact: TechCoverContact): Promise<TechCoverContactEdit> {
    const response = await firstValueFrom(
      this.http.post<TechCoverContact>(`${this.baseUrl_V2}`, contact),
    );
    return new TechCoverContactEdit().deserialize(response);
  }

  public async update(contact: TechCoverContact): Promise<TechCoverContactEdit> {
    const response = await firstValueFrom(
      this.http.put<TechCoverContact>(`${this.baseUrl_V2}/${contact.famCode}`, contact),
    );
    return new TechCoverContactEdit().deserialize(response);
  }

  public async delete(contact: TechCoverContact): Promise<void> {
    await firstValueFrom(this.http.delete(`${this.baseUrl_V2}/${contact.famCode}`));
    return Promise.resolve();
  }
}
